// app/javascript/controllers/tooltip_controller.js
import { Controller } from "@hotwired/stimulus"
import { createPopper } from "@popperjs/core"

export default class extends Controller {
  static targets = ["trigger", "content"]
  static values = {
    placement: { type: String, default: "top" },
    offset: { type: Array, default: [0, 8] }
  }

  connect() {
    this.popperInstance = createPopper(this.triggerTarget, this.contentTarget, {
      placement: this.placementValue,
      strategy: 'fixed', // <--- THIS IS THE KEY FIX
      modifiers: [
        {
          name: "offset",
          options: {
            offset: this.offsetValue,
          },
        },
        {
          name: "preventOverflow",
          options: {
            boundary: 'viewport',
            padding: 8, // Keep 8px away from screen edges
          },
        },
        {
          name: "flip", // Flips to bottom if top has no space
          options: {
            padding: 8,
          },
        },
      ],
    })

    this.handleDocumentClick = this.handleDocumentClick.bind(this)
  }

  // ... rest of the controller (disconnect, toggle, show, hide) remains the same ...
  disconnect() {
    if (this.popperInstance) {
      this.popperInstance.destroy()
    }
    document.removeEventListener("click", this.handleDocumentClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.contentTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.contentTarget.classList.remove("hidden")
    this.popperInstance.update()
    document.addEventListener("click", this.handleDocumentClick)
  }

  hide() {
    this.contentTarget.classList.add("hidden")
    document.removeEventListener("click", this.handleDocumentClick)
  }

  handleDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}
